import { gql } from '@apollo/client'
import { userErrorFragment } from '~/graphql/fragments/userError'

export const CHANGE_USER_LOCALE = gql`
  mutation ChangeUserLocale($input: ChangeUserLocaleInput!) {
    changeUserLocale(input: $input) {
      user {
        id
      }
      errors {
        ...userError
      }
    }
  }

  ${userErrorFragment}
`
